"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = exports.default = {
  SIZE: 'data-size',
  STATUS: 'data-status',
  PREFIX: 'data-prefix',
  DISABLED: 'data-disabled',
  HOVER: 'data-hover',
  FOCUS: 'data-focus',
  LEFTBORDERRADIUS: 'data-left-border-radius',
  RIGHTBORDERRADIUS: 'data-right-border-radius'
};
//# sourceMappingURL=DataAttr.js.map